/**
 * Petstyle24 – Produkt-Angebot (sections/product-offer.liquid; Wünsche-Runde GOLIVE_2, W-B Weg A, D-057 Nr. 2).
 *
 * <ps-offer> hält das native Produktformular der Section (ohne JavaScript postet der Browser an /cart/add).
 *   - Größenwechsel (Radio name="id" der Größenauswahl): den servergerenderten Preis der gewählten Größe einblenden
 *     ([data-ps-offer-price], Muster sections/size-sheet.liquid / assets/ps-size-sheet.js sync()), den Badge-Platz
 *     [data-ps-offer-badge] nach data-ps-offer-sale der Größe zeigen, den Knopf bei ausverkaufter Größe sperren.
 *     Keine Preisrechnung im Browser – alle Beträge kommen aus dem Markup.
 *   - Absenden [data-ps-offer-form]: nur über Petstyle24.cart.add(id, 1, { trigger }) (Adapter assets/ps-cart.js: Drawer,
 *     Ansage, Fehlertexte); Knopfzustände wie assets/ps-product.js (aria-disabled statt disabled, aria-busy, „Wird
 *     hinzugefügt …“, „Hinzugefügt“ mit Häkchen für 2 s, Fehler im Alert [data-ps-offer-error]). Texte aus den
 *     data-Attributen des Elements. Menge fest 1.
 * Kein eigener Zugriff auf Cart-Routen (Prüfung 19), kein Browser-Speicher, keine Konsole, kein HTML-Einfügen, kein Dialog.
 */
(() => {
  'use strict';

  if (customElements.get('ps-offer')) return;

  const PS = window.Petstyle24;
  const ADDED_MS = 2000;

  const setLabel = (button, value) => {
    const label = button.querySelector('.button__label');
    if (label && value) label.textContent = value;
  };

  const setIcon = (button, visible) => {
    const icon = button.querySelector('.button__icon');
    if (icon) icon.hidden = !visible;
  };

  class PsOffer extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('change', (event) => this.onChange(event));
      this.addEventListener('submit', (event) => this.onSubmit(event));
      this.sync();
    }

    button() {
      return this.querySelector('[data-ps-offer-submit]');
    }

    /* gewählte Größe: Radio der Größenauswahl oder das verborgene Feld bei nur einer Variante */
    field() {
      return this.querySelector('[data-ps-size-selector] input[name="id"]:checked') || this.querySelector('input[type="hidden"][name="id"]');
    }

    onChange(event) {
      const target = event.target instanceof Element ? event.target : null;
      if (target && target.matches('[data-ps-size-selector] input[name="id"]')) this.sync();
    }

    /* Preis, Badge und Knopf folgen der gewählten Größe – alles servergerendert, hier nur ein- bzw. ausgeblendet.
       Ohne Formular (Section ohne Knopftext, Skript über eine andere Angebot-Section geladen) bleibt das Markup, wie Liquid es liefert. */
    sync() {
      if (!this.querySelector('[data-ps-offer-form]')) return;
      const field = this.field();
      const key = field ? field.value : 'none';
      let current = null;
      this.querySelectorAll('[data-ps-offer-price]').forEach((node) => {
        const match = node.dataset.psOfferPrice === key;
        node.hidden = !match;
        if (match) current = node;
      });
      const badge = this.querySelector('[data-ps-offer-badge]');
      if (badge) badge.hidden = !(current && current.dataset.psOfferSale === 'true');
      const button = this.button();
      if (!button || button.classList.contains('is-loading')) return;
      const soldOut = !field || field.disabled || !current || current.dataset.psOfferAvailable !== 'true';
      button.disabled = soldOut;
      setIcon(button, false);
      setLabel(button, soldOut ? this.dataset.soldOut : this.dataset.label);
    }

    async onSubmit(event) {
      const form = event.target instanceof HTMLFormElement ? event.target : null;
      if (!form || !form.matches('[data-ps-offer-form]') || !PS || !PS.cart) return;
      event.preventDefault();

      const button = this.button();
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      const field = this.field();
      if (!field || field.disabled) return;

      const error = this.querySelector('[data-ps-offer-error]');
      if (error) error.textContent = '';
      // Laden: aria-disabled statt disabled, damit der Tastaturfokus auf dem Knopf bleibt (wie ps-product.js)
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');
      button.classList.add('is-loading');
      setLabel(button, this.dataset.adding);

      const result = await PS.cart.add(field.value, 1, { trigger: button });
      if (!button.isConnected) return;

      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
      if (!result || !result.ok) {
        setLabel(button, this.dataset.label);
        if (error) error.textContent = (result && result.error) || this.dataset.error || '';
        return;
      }
      setIcon(button, true);
      setLabel(button, this.dataset.added);
      window.setTimeout(() => {
        if (!button.isConnected) return;
        setIcon(button, false);
        setLabel(button, this.dataset.label);
      }, ADDED_MS);
    }
  }

  customElements.define('ps-offer', PsOffer);
})();
